import { Component, inject, input, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReloadService } from './reload.service';


@Component({
    selector: 'reload-bar',
    providers: [
        ReloadService,
    ],
    template: `
        @if (bar()) {
            <div role="alert" animate.enter="slide-up-down-enter" animate.leave="slide-up-down-leave" class="alert-{{ bar()?.type }} text-center px-2 py-1">
                {{ bar()?.message }}
                @if (bar()?.showReload) {
                    <button class="btn btn-success btn-sm" (click)="reload()">Reload</button>
                }
            </div>
        }
    `,
})
export class ReloadBarComponent implements OnInit {

    version = input.required<string>();

    frequency = input(1000 * 60 * 5);

    reloadService = inject(ReloadService);

    bar = toSignal(this.reloadService.reloadBar, { requireSync: true });

    ngOnInit() {
        this.reloadService.initialize(this.version(), this.frequency());
    }

    reload() {
        this.reloadService.reload();
    }
}
